import { MAX_KM_PER_LITRE, type CreateTruckInput } from '@chukua/common';
import { Form, InputNumber, Switch } from 'antd';
import { CAPACITY_TONNES_RULES } from '../../../../../shared/policies/capacity-tonnes-rules';

const CAPABILITY_FIELDS: { name: keyof CreateTruckInput; label: string }[] = [
  { name: 'hasGenset', label: 'Genset' },
  { name: 'isBonded', label: 'Bonded' },
  { name: 'isHazardousCertified', label: 'Hazardous-certified' },
  { name: 'isCrossBorderEquipped', label: 'Cross-border equipped' },
];

/** Capacity, tank size and the job-fit capability flags — shared by create and edit (CreateTruckDrawer, TruckDetailsForm). */
export function TruckCapabilityFields() {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="capacityTonnes" label="Capacity (t)" rules={CAPACITY_TONNES_RULES}>
          <InputNumber className="w-full" min={0.01} step={0.5} />
        </Form.Item>
        <Form.Item name="tankCapacityLitres" label="Tank (L)" rules={[{ required: true, message: 'Enter tank capacity' }]}>
          <InputNumber className="w-full" min={1} step={10} />
        </Form.Item>
      </div>
      <Form.Item
        name="expectedKmPerLitre"
        label="Expected consumption (km/l)"
        extra="Where its fuel figure starts until it has enough trips of its own. Leave empty to use its class's default."
      >
        <InputNumber className="w-full" min={0.1} max={MAX_KM_PER_LITRE} step={0.1} />
      </Form.Item>
      <div className="mb-2 grid grid-cols-2 gap-x-4 gap-y-2">
        {CAPABILITY_FIELDS.map(({ name, label }) => (
          <Form.Item key={name} name={name} label={label} valuePropName="checked" className="mb-0">
            <Switch />
          </Form.Item>
        ))}
      </div>
    </>
  );
}
